import VueCookie from "vue-cookie";
import config from "@/assets/config";

/**
 * COOKIES
 */

const state = () => ({
  token: null,
  userid: null,
  useruid: null,
  username: null,
  timezone: null,
  projectid: null,
  entity: null,
  projectname: null,
  caseid: null,
  taskid: null,
  idLog: null,
  stateKardex: null,
  lastprotocol: null,
  plantillacorreouid: null,
  plantilladocid: null,
  plantillapdfuid: null,
  plantillainiciouid: null,
});

const mutations = {
  resetPv(state) {
    VueCookie.delete(config.cookie.pv_id);
    VueCookie.delete(config.cookie.pv_nombre);
  },
  resetCookie(state) {
    state.token = null;
    state.userid = null;
    state.useruid = null;
    state.username = null;
    state.timezone = null;
    state.caseid = null;
    state.taskid = null;
    state.projectid = null;
    state.entity = null;
    state.projectname = null;
    state.idLog = null;
    state.stateKardex = null;
    state.lastprotocol = null;
    state.plantillacorreouid = null;
    state.plantillapdfuid = null;
    state.plantilladocid = null;
    state.plantillainiciouid = null;
    let keys = Object.keys(config.cookie);
    keys.forEach((item) => {
      if (item != "pv_id" && item != "pv_nombre") {
        VueCookie.delete(config.cookie[item]);
      }
    });
    // Aislamiento total entre sesiones: en localStorage solo hay contexto de
    // la sesión/entidad (token, filtros, plan, protocolo seleccionado,
    // preferencias de tablas); nada debe sobrevivir a un cierre de sesión.
    try {
      localStorage.clear();
    } catch (error) {
      console.error(error);
    }
  },
  setHeader(state, user) {
    try {
      state.userid = user.id;
      state.useruid = user.uid;
      state.username = user.nombre;
      state.timezone = user.zonaHoraria;
      state.token = user.token;
      state.entity = user.entidad
      localStorage.setItem(config.cookie.token, user.token);
      VueCookie.set(config.cookie.token, user.token);
      VueCookie.set(config.cookie.username, user.nombre);
      VueCookie.set(config.cookie.userid, user.id);
      VueCookie.set(config.cookie.useruid, user.uid);
      VueCookie.set(config.cookie.timezone, "");
      VueCookie.set(config.cookie.entity, user.entidad)
    } catch (error) {
      console.error(error);
    }
  },
  setStateCookie(state, item) {
    state[item.key] = item.value;
    if (item.value) VueCookie.set(item.key, item.value);
    else VueCookie.delete(item.key);
  },
};

const getters = {
  getStateCookie: (state) => (key) => {
    try {
      if (key == config.cookie.token) {
        return localStorage.getItem(config.cookie.token);
      } else {
        let data = state[key];
        if (data) state[key] = VueCookie.get(key);
        return VueCookie.get(key);
      }
    } catch (error) {
      console.error(error);
      return undefined;
    }
  },
  getHeader(state) {
    try {
      state.token = localStorage.getItem(config.cookie.token);
      if (!state.userid) state.userid = VueCookie.get(config.cookie.userid);
      if (!state.projectid) state.projectid = VueCookie.get(config.cookie.projectid);
      if (!state.useruid) state.useruid = VueCookie.get(config.cookie.useruid);
      if (!state.caseid) state.caseid = VueCookie.get(config.cookie.caseid);
      if (!state.taskid) state.taskid = VueCookie.get(config.cookie.taskid);
      if (!state.entity) state.entity = VueCookie.get(config.cookie.entity)
      return {
        token: state.token,
        "user-id": state.userid,
        projectid: state.projectid,
        caseid: state.caseid,
        taskid: state.taskid,
        useruid: state.useruid,
        entity: state.entity,
        "api-key": "b95c343f68da77b7b02cb240f911c434bdd39d30116ce3ef5ce233281cbc55f5",
      };
    } catch (error) {}
  },
  user_logged(state) {
    try {
      if (!state.userid) state.userid = VueCookie.get(config.cookie.userid);
      if (!state.username) state.username = VueCookie.get(config.cookie.username);
      if (!state.useruid) state.useruid = VueCookie.get(config.cookie.useruid);
      if (!state.timezone) state.timezone = VueCookie.get(config.cookie.timezone);

      return {
        useruid: state.useruid,
        userid: state.userid,
        username: state.username,
        timezone: state.timezone,
      };
    } catch (error) {}
  },
};

const actions = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
